export default __webpack_public_path__ + "static/banner5-c001462adc7eb2a3424a703095f98f6f.jpeg";